import { Button, chakra } from "@chakra-ui/react";

export const RegisterSubscriberButton = chakra(Button, {
  baseStyle: {
    w: "fit-content",
    h: "44px",
    px: "20px",
    pl: "16px",
    gap: "10px",
    bg: "#1819B4",
    color: "#fff",
    fontWeight: "600",
    fontSize: "16px",
    fontFamily: "Poppins",
    borderRadius: "8px",
    m: "2",
    _hover: {
      bg: "#1516A0",
    },
  },
});

export const ExcelUploadButton = chakra(Button, {
  baseStyle: {
    w: "fit-content",
    h: "44px",
    px: "20px",
    pl: "16px",
    gap: "10px",
    bg: "#16A34A",
    color: "#fff",
    fontWeight: "600",
    fontSize: "16px",
    fontFamily: "Poppins",
    borderRadius: "8px",
    m: "2",
    _hover: {
      bg: "#15803D",
    },
  },
});